export const generalRoute = {
  home: "/",
  becomeATalent: "/become-a-talent",
  discoverTalents: "/discover-talents",
  hireATalent: "/hire-a-talent",
};
